import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { ImagesService } from './services/images.service';
import { Logger } from '@app/core/logging/logger.service';
import { Observable } from 'rxjs';

export interface ISrcSet {
  width: string;
  height: string;
  auto?: string;
  otherParams?: string;
  descriptor?: string;
}

@Component({
  selector: 'vc-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImagesComponent implements OnInit, OnChanges {
  @Input()
  url: string;
  @Input()
  alt: string;
  @Input()
  width: number;
  @Input()
  height: number;
  @Input()
  auto: string;
  @Input()
  lazyOff = false;
  @Input()
  cropWidthCenteredSm = false;
  @Input()
  eventToObserve: Observable<Event>;

  /**
   * srcSet + sizes attributes
   * imgSrcSet input is a list of params needed to construct url
   */

  @Input()
  imgSrcSet: [ISrcSet];
  @Input()
  sizes: string;

  srcSet: string;

  urlImage: string;
  urlDefaultImage: string;

  constructor(private logger: Logger) {}

  ngOnInit() {
    this.buildImagesUrl();
    if (this.imgSrcSet) {
      this.buildSrcset();
    }
    this.setDefaultImage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.buildImagesUrl();
  }

  setDefaultImage() {
    const defaultImagePath = '/notFound/placeholder.jpg';
    this.urlDefaultImage = ImagesService.buildUrl(defaultImagePath, { w: this.width, h: this.height });
  }

  buildImagesUrl() {
    if (this.alt === '') {
      this.logger.warn('Missing alt on Image on ' + this.url);
    }
    this.urlImage = ImagesService.buildUrl(this.url, { w: this.width, h: this.height });
  }

  buildSrcset() {
    const srcSetLenght = this.imgSrcSet.length;
    this.imgSrcSet.forEach((src: ISrcSet, idx) => {
      if (this.srcSet) {
        this.srcSet += ImagesService.buildUrl(this.url, { w: src.width, h: src.height });
      } else {
        this.srcSet = ImagesService.buildUrl(this.url, { w: src.width, h: src.height });
      }
      /*if (src.otherParams) {
        this.srcSet += `${src.otherParams}`;
      }*/
      if (src.descriptor) {
        this.srcSet += ` ${src.descriptor}`;
      }
      if (idx <= srcSetLenght) {
        this.srcSet += ', ';
      }
    });
  }
}
